import MailIcon from '@mui/icons-material/Mail'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'
import { memo } from 'react'
import type { IconProps } from '.'

const Mail = memo((props: IconProps) => {
    const { filled, color, title } = props
    const Icon = filled ? MailIcon : MailOutlinedIcon
    return <Icon data-testid="Icon__Mail" css={{ color }} titleAccess={title} />
})

export default Mail
